import axios from "axios";

export default {
	listUsers(ctx) {
		return axios.get("/v3/users", { params: ctx });
	},

	getUser(id) {
		return axios.get(`/v3/user/${id}`);
	},

	

	saveUser(user) {
		if (user.password || user.password == "") {
			return axios.post("/v3/user+pass", {
				password: user.password,
				user: user
			});
		} else {
			return axios.post("/v3/user", user);
		}
	},

	removeUser(id) {
		return axios.delete(`/v3/user/${id}`);
	},

	activate(user) {
		return axios.post(`/v3/user/${user.id}/activate`);
	},

	deactivate(user) {
		return axios.post(`/v3/user/${user.id}/deactivate`);
	},

	archive(user) {
		return axios.post(`/v3/user/${user.id}/archive`);
	},

	unarchive(user) {
		return axios.post(`/v3/user/${user.id}/unarchive`);
	},

	validateImportUsers(request) {
		return axios.post(`/v3/import/users/valid`, request);
	},

	importUsers(request) {
		return axios.post(`/v3/import/users`, request);
	},

	updateProfile(profile) {
		let update = {
			user: profile,
			password: profile.password
		};
		return axios.post("/v3/profile", update);
	},

	getPersonalNote(itemID) {
		return axios.get(`/v3/personal_note/${itemID}`);
	},

	savePersonalNote(itemID, note) {
		return axios.post(`/v3/personal_note/${itemID}`, note);
	},


	//Scan / Media upload
	getUserNoauth(id){
		return axios.get(`/v3/auser/${id}`);
	},

	getAvailableAssessments(id){
		return axios.get(`/v3/media_entry/${id}`)
	}
};



// WEBPACK FOOTER //
// ./src/services/UserService.js